import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { FinanceReportsModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[FinanceReports] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[FinanceReports] Load items success', props<{ data: PaginationAdapter<FinanceReportsModel> }>());

// item
export const loadItem = createAction('[FinanceReports] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[FinanceReports] Load item success', props<{ item: FinanceReportsModel }>());
